import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ProtectAPi } from '../../../../api/ProtectAPi';
import swal from 'sweetalert';
import BackButton from '../../../tools/BackButton';
import Select from 'react-select';
import { ServerUrl } from '../../../../api/ServerUrl';

const BackImageEdit = () => {
    const { http } = ProtectAPi();
    const { id } = useParams();
    const navigate = useNavigate();

    const [loader, setLoader] = useState('off');
    const [layoutImage, setLayoutImage] = useState(null);
    const [layoutImageError, setLayoutImageError] = useState('');
    const [imagePreview, setImagePreview] = useState('');

    const [ogImage, setOgImage] = useState(null);
    const [ogImageError, setOgImageError] = useState('');
    const [ogImagePreview, setOgImagePreview] = useState('');

    const [pageName, setPageName] = useState('');
    const [pageNameError, setPageNameError] = useState('');

    const [altText, setAltText] = useState('');
    const [metaTitle, setMetaTitle] = useState('');
    const [metaDescription, setMetaDescription] = useState('');
    const [ogTitle, setOgTitle] = useState('');
    const [ogDescription, setOgDescription] = useState('');
    const [seoErrors, setSeoErrors] = useState({});

    useEffect(() => {
        http.get(`/get-single-back-image/${id}`)
            .then(res => {
                const data = res.data;
                setPageName(data.page_name);
                setAltText(data.alt_text || '');
                setMetaTitle(data.meta_title || '');
                setMetaDescription(data.meta_description || '');
                setOgTitle(data.og_title || '');
                setOgDescription(data.og_description || '');

                if (data.image) {
                    setImagePreview(`${ServerUrl}/backend/img/back_image/${data.image}`);
                }
                if (data.og_image) {
                    setOgImagePreview(`${ServerUrl}/backend/img/back_image/${data.og_image}`);
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }, [id]);

    const handleImageChange = (e) => {
        const selectedImage = e.target.files[0];
        setLayoutImage(selectedImage);
        setImagePreview(URL.createObjectURL(selectedImage));
    };

    const handleOgImageChange = (e) => {
        const selectedImage = e.target.files[0];
        setOgImage(selectedImage);
        setOgImagePreview(URL.createObjectURL(selectedImage));
    };

    const handlePageNameChange = (selectedOption) => {
        setPageName(selectedOption.value);
    };

    const submitForm = () => {
        setLoader('on');
        const formData = new FormData();
        formData.append('image', layoutImage);
        formData.append('og_image', ogImage);
        formData.append('page_name', pageName);
        formData.append('alt_text', altText);
        formData.append('meta_title', metaTitle);
        formData.append('meta_description', metaDescription);
        formData.append('og_title', ogTitle);
        formData.append('og_description', ogDescription);

        http.post(`/update-back-image/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => {
            if (res.data.status === '422') {
                const errors = res.data.error;
                setLayoutImageError(errors.image ?? '');
                setOgImageError(errors.og_image ?? '');
                setPageNameError(errors.page_name ?? '');
                setSeoErrors({
                    altText: errors.alt_text ?? '',
                    metaTitle: errors.meta_title ?? '',
                    metaDescription: errors.meta_description ?? '',
                    ogTitle: errors.og_title ?? '',
                    ogDescription: errors.og_description ?? ''
                });
                setLoader('off');
            } else {
                swal('Success', res.data.msg, 'success');
                navigate('/admin/pages/background-image-list');
                setLoader('off');
            }
        }).catch(error => {
            console.error('Error:', error);
            setLoader('off');
        });
    };

    const options = [
        { value: 'About Us', label: 'About Us' },
        { value: 'Mission Vision', label: 'Mission Vision' },
        { value: 'Services', label: 'Services' },
        { value: 'Case Study', label: 'Case Study' },
        { value: 'Products', label: 'Products List' },
        { value: 'Our Factory', label: 'Our Factory' },
        { value: 'Testimoniul', label: 'Testimoniul' },
        { value: 'FHIH', label: 'FHIH' },
        { value: 'Contact Us', label: 'Contact Us' },
        { value: 'Search Result', label: 'Search Result' },
        { value: 'Publications', label: 'Publications' },
        { value: 'Appoinment', label: 'Appoinment' },
        { value: 'Award List', label: 'Award List' },
        { value: 'Blog List', label: 'Blog List' },
    ];

    return (
        <div className="main-content">
            <section className="section">
                <div className="section-body">
                    <div className="row">
                        <div className="col-12">
                            <div className="card card-primary">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between">
                                        <h5>Edit Background Image & SEO Info</h5>
                                        <BackButton />
                                    </div>

                                    <div className="row mt-4">
                                        {/* Background Image */}
                                        <div className="col-md-6 mb-4">
                                            <label>Background Image</label>
                                            <small className='d-block'>Size: 1500×300 px</small>
                                            <label htmlFor="layoutImage">
                                                <div className="image-box border p-2 rounded mt-2 text-center">
                                                    <img
                                                        src={imagePreview || "https://w7.pngwing.com/pngs/159/705/png-transparent-computer-computer-trademark-computer-logo.png"}
                                                        className="w-100"
                                                        style={{ maxHeight: '150px', objectFit: 'contain' }}
                                                        alt="BG Preview"
                                                    />
                                                </div>
                                                <input type="file" id="layoutImage" className="d-none" onChange={handleImageChange} />
                                                <span className='btn btn-primary mt-1 w-100'>Upload BG Image</span>
                                            </label>
                                            <span className='text-danger'>{layoutImageError}</span>
                                        </div>

                                        {/* OG Image */}
                                        <div className="col-md-6 mb-4">
                                            <label>Open Graph Image</label>
                                            <small className='d-block'>Size: 1200×630 px (Recommended)</small>
                                            <label htmlFor="ogImage">
                                                <div className="image-box border p-2 rounded mt-2 text-center">
                                                    <img
                                                        src={ogImagePreview || "https://w7.pngwing.com/pngs/159/705/png-transparent-computer-computer-trademark-computer-logo.png"}
                                                        className="w-100"
                                                        style={{ maxHeight: '150px', objectFit: 'contain' }}
                                                        alt="OG Preview"
                                                    />
                                                </div>
                                                <input type="file" id="ogImage" className="d-none" onChange={handleOgImageChange} />
                                                <span className='btn btn-primary mt-1 w-100'>Upload OG Image</span>
                                            </label>
                                            <span className='text-danger'>{ogImageError}</span>
                                        </div>

                                        {/* Page Name */}
                                        <div className="col-md-12 mb-4">
                                            <label>Page Name</label>
                                            <Select
                                                options={options}
                                                value={{ value: pageName, label: pageName }}
                                                onChange={handlePageNameChange}
                                            />
                                            <span className='text-danger'>{pageNameError}</span>
                                        </div>

                                        {/* ALT Text */}
                                        <div className="col-md-12 mb-4">
                                            <label>Image ALT Text</label>
                                            <input type="text" className="form-control" value={altText} onChange={(e) => setAltText(e.target.value)} />
                                            <span className='text-danger'>{seoErrors.altText}</span>
                                        </div>

                                        {/* Meta Title */}
                                        <div className="col-md-12 mb-4">
                                            <label>Meta Title (Max 60 chars)</label>
                                            <input type="text" className="form-control" maxLength={60} value={metaTitle} onChange={(e) => setMetaTitle(e.target.value)} />
                                            <span className='text-danger'>{seoErrors.metaTitle}</span>
                                        </div>

                                        {/* Meta Description */}
                                        <div className="col-md-12 mb-4">
                                            <label>Meta Description (Max 160 chars)</label>
                                            <textarea className="form-control" maxLength={160} value={metaDescription} onChange={(e) => setMetaDescription(e.target.value)} rows="2" />
                                            <span className='text-danger'>{seoErrors.metaDescription}</span>
                                        </div>

                                        {/* OG Title */}
                                        <div className="col-md-12 mb-4">
                                            <label>Open Graph Title</label>
                                            <input type="text" className="form-control" value={ogTitle} onChange={(e) => setOgTitle(e.target.value)} />
                                            <span className='text-danger'>{seoErrors.ogTitle}</span>
                                        </div>

                                        {/* OG Description */}
                                        <div className="col-md-12">
                                            <label>Open Graph Description</label>
                                            <textarea className="form-control" value={ogDescription} onChange={(e) => setOgDescription(e.target.value)} rows="2" />
                                            <span className='text-danger'>{seoErrors.ogDescription}</span>
                                        </div>

                                        {/* Submit */}
                                        <div className="col-md-12 mb-4 mt-5 text-center">
                                            {loader === 'off' ? (
                                                <button onClick={submitForm} className="btn btn-primary btn-lg">Update</button>
                                            ) : (
                                                <div className="spinner-border text-dark" role="status"></div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default BackImageEdit;
